import React, { useState, useRef, useEffect } from 'react'
import ArrowDown from '../assets/iconTsx/DropDown'

import classNames from 'classnames'
import useClickOutside from '../hooks/useOnclickOutside'

interface Option {
  icon?: string
  value: string
  label: string
  bientot?: boolean
  background?: string
}

interface CustomSelectProps {
  options: Option[]
  value: string
  onChange: (selectedValue: string) => void
  placeholder?: string
  icon?: string
  width?: string
  height?: string
  textSize?: string
  background?: string
  showArrow?: boolean
  heightDropdown?: string
  marginRight?: string
  textColor?: string
  marginRightIcon?: string
  iconSelect?: string
  roundedIcon?: string
  phonePrefix?: any
  flag?: string
  disableMaroc? : boolean
  heightListe?: string
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  value,
  onChange,
  placeholder,
  icon,
  width,
  height,
  textSize,
  showArrow,
  background,
  heightDropdown = 'h-[200px]',
  marginRight,
  textColor,
  marginRightIcon,
  iconSelect,
  roundedIcon,
  phonePrefix,
  disableMaroc = false,
  heightListe='h-[40px] text-[15px]',
  flag,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [optionSelect, setOptionSelect]= useState<string | null>(value)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  useEffect(()=>{
    setOptionSelect(value)
  },[value])

  const handleOptionClick = (selectedValue: string) => {
    if (!disableMaroc || disableMaroc && selectedValue === 'Tunisie'){
    onChange(selectedValue)
    setIsOpen(false)
    setOptionSelect(selectedValue)
  }
    

  }
  const divRef = useRef<HTMLDivElement>(null)
  const dropDownRef = useRef<HTMLDivElement>(null)
  const toggleSetting = () => setIsOpen(false)
  useClickOutside(toggleSetting, dropDownRef, divRef)


  return (
    <div className={classNames(height, '  font-roboto  font-medium')} ref={divRef}>
      <div
        className={` h-full  rounded-lg text-[#35258B] shadow-sm flex items-center justify-between   
          ${showArrow && 'hover:cursor-pointer hover:border hover:border-[#5754E5]'}  
          ${background ? background : 'bg-[#F5F5F5] '}`}
          onClick={handleToggle}
      >
        <div className="flex gap-1 items-center  justify-center">
          {icon && (
            <img
              className={`  ${roundedIcon ? roundedIcon : 'rounded-[50%]'}`}
              src={icon}
              alt=""
              width={25}
              height={25}
            />
          )}

          {value ? (
            <span
              className={classNames(
                textSize,
                `whitespace-nowrap flex text-[#35258B] flex-col  ${isOpen && 'text-[#5754E5]'}`,
              )}
            >
              {flag && value ? flag : value}
            </span>
          ) : (
            <span className={classNames(textSize, ' whitespace-nowrap text-[#D1D1FF]  ')}>{placeholder}</span>
          )}
        </div>

        {showArrow ? (
          <ArrowDown styleCssImage={`${marginRightIcon}  ${isOpen ? 'fill-[#5754E5] rotate-180' : 'fill-[#AEB6FB]'} `}/>

          // <img
          //   src={iconSelect ? iconSelect : ArrowDown}
          //   alt=""
          //   className={`${marginRightIcon ? marginRightIcon : 'h-10'}`}
          //   width={10}
          //   height={10}
          // />
        ) : (
          <div className="w-[40px]" />
        )}
      </div>
      {isOpen && showArrow && (
        <div
          ref={dropDownRef}
          className={classNames(
            
            heightDropdown,
            'absolute mt-1   bg-white border border-[#E5E7EB]',
            'rounded-lg shadow-lg overflow-auto',
            // ' absolute   z-50  bg-[#FFFFFF]  shadow-selct  rounded mt-1 overflow-auto  ',
          )}
        >
          {options.map((option: any, index: number) => (
            <span
              key={index}
              className={` ${heightListe} px-2 z-50 py-2   text-[#35258B]  hover:text-[#4D36CC] sm:text-[12px] w-full cursor-pointer flex gap-2 items-center ${
                option.label === 'Maroc' || option.bientot === true && 'text-[#424242] bg-white   hover:bg-transparent cursor-default'
              } ${optionSelect === option.label && 'bg-[#F1F1FF] text-[#5754E5] '} `}
               onClick={() => {
                if(!option.bientot){
                handleOptionClick(option.label)}} }
            >
              {option.bientot}
              {option?.icon && <img src={option?.icon} alt="pays de destination" width={25} height={25} />}
              {option.flag ? option.flag : option.label}
              {option.label === 'Maroc'  || option.bientot === true  && (
                <div className="bg-[#EE443F] text-[#FFFFFF] text-[8px] px-[4px] rounded-sm ">
                  Bientôt
                </div>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default CustomSelect
